import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { XmarkStroke } from '@lineiconshq/free-icons';
import React from 'react';
import { Dialog, DialogOverlay, DialogPortal, DialogTitle } from '@/components/ui/dialog';
import { AritoFormV2, BottomActionBarV2, AritoIcon } from '@/components/custom/erp';
import { SearchFormValues, searchSchema } from '../../schema';
import { useDialogStack } from '@/hooks/use-dialog-stack';
import BasicInfoTab from './BasicInfoTab';
import { useDetailRows } from './hooks';
import DetailTab from './DetailTab';

interface OtherDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (filters: MuaHangRecord) => void;
}

const OtherDialog = ({ open, onClose, onSearch }: OtherDialogProps) => {
  const { contentZIndex, overlayZIndex } = useDialogStack(open);
  const {
    rows: detailRows,
    selectedRowUuid: detailSelectedRowUuid,
    handleRowClick: detailHandleRowClick,
    handleCellValueChange: detailHandleCellValueChange
  } = useDetailRows();

  const handleSubmit = (data: SearchFormValues) => {
    onSearch(data);
    onClose();
  };

  return (
    <Dialog modal={true} open={open} onOpenChange={onClose}>
      <DialogPortal>
        <DialogOverlay className='fixed inset-0 bg-black/50' style={{ zIndex: overlayZIndex }} />
        <div className='fixed inset-0 flex items-center justify-center p-4' style={{ zIndex: contentZIndex }}>
          <DialogPrimitive.Content
            onOpenAutoFocus={event => event.preventDefault()}
            onCloseAutoFocus={event => event.preventDefault()}
            onInteractOutside={event => event.preventDefault()}
            onPointerDownOutside={event => event.preventDefault()}
            onFocusOutside={event => event.preventDefault()}
            className='flex max-h-[85vh] w-[820px] flex-col overflow-hidden border border-[#cfd8e3] bg-white shadow-lg outline-none'
          >
            <div className='flex h-11 min-h-11 items-center justify-between border-b border-[#d1d5db] bg-[#f2f7fc] pl-3.5 pr-4'>
              <DialogTitle className='flex items-center text-[16px] font-bold text-black'>
                <AritoIcon icon={12} className='mx-2' />
                <span>Chi tiết chứng từ được chọn</span>
              </DialogTitle>
              <button type='button' onClick={onClose} className='inline-flex size-8 items-center justify-center'>
                <Lineicons aria-hidden='true' icon={XmarkStroke} className='size-[18px]' />
              </button>
            </div>
            <AritoFormV2
              mode='add'
              hasAritoActionBar={false}
              schema={searchSchema}
              onSubmit={handleSubmit}
              className='w-[800px]'
              headerFields={<BasicInfoTab formMode='add' />}
              tabs={[
                {
                  id: 'detail',
                  label: 'Chi tiết',
                  component: (
                    <DetailTab
                      formMode='add'
                      rows={detailRows}
                      selectedRowUuid={detailSelectedRowUuid}
                      onCellValueChange={detailHandleCellValueChange}
                    />
                  )
                }
              ]}
              bottomBar={<BottomActionBarV2 onClose={onClose} mode='search' submitTitle='Đồng ý' />}
            />
          </DialogPrimitive.Content>
        </div>
      </DialogPortal>
    </Dialog>
  );
};

export default OtherDialog;
